import React from 'react';
import clsx from 'clsx';

import scss from './BackgroundImage.module.scss';

function BackgroundImage({ src, alt = 'background', className, ...props }) {
  if (!src) return null;

  return <img src={src} alt={alt} className={clsx(className, scss.backgroundImage)} aria-hidden='true' {...props} />;
}

export default BackgroundImage;
